/**
 * @file Generated by js-routes 2.4.1. Based on Rails 8.1.3.1 routes of Controldoc::Application.
 * @version 08ce09880e056cf26fab95b479d74db8c63f3907bfd27c4a2b65b4586397e6e4
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: false,
        include_undefined_query_parameters: true,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/load/documents/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_bulk_load_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/load/documents(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_bulk_load_documents_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/load/entities(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_bulk_load_entities_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"entities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/load/entities/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_bulk_load_entity_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"entities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/notification/signs/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_bulk_notification_sign_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[6,"signs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/notification/signs(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_bulk_notification_signs_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[6,"signs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/request/documents/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_bulk_request_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/request/documents(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_bulk_request_documents_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/request/entity_items/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_bulk_request_entity_item_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"entity_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/request/zip/documents/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_bulk_request_zip_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/request/zip/documents(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_bulk_request_zip_documents_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/check_list/processes/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_check_list_process_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/check_list/processes(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_check_list_processes_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"processes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/check_list/tasks/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_check_list_task_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/check_list/tasks(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_check_list_tasks_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/controldoc_form/documents/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_controldoc_form_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/controldoc_form/documents(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_controldoc_form_documents_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/controldoc_form/templates/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_controldoc_form_template_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/controldoc_form/template_layouts/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_controldoc_form_template_layout_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"template_layouts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/controldoc_form/template_layouts(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_controldoc_form_template_layouts_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"template_layouts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/controldoc_form/templates(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_controldoc_form_templates_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/custom_fields/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_custom_field_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/custom_fields(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_custom_fields_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"custom_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/documents/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/document_types/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_document_type_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/document_type_batteries(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_document_type_batteries_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"document_type_batteries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/document_type_batteries/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_document_type_battery_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"document_type_batteries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/document_types(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_document_types_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/documents(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_documents_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entities(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_entities_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entities/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_entity_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_lists/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_entity_folder_check_list_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_list_requirements/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_entity_folder_check_list_requirement_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_requirements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_list_requirements(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_entity_folder_check_list_requirements_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_list_shareds/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_entity_folder_check_list_shared_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_shareds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_list_shareds(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_entity_folder_check_list_shareds_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_shareds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_list_tasks/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_entity_folder_check_list_task_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_list_tasks(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_entity_folder_check_list_tasks_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_lists(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_entity_folder_check_lists_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/fao/mapping_configs/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_fao_mapping_config_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"fao"],[2,[7,"/"],[2,[6,"mapping_configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/fao/mapping_configs(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_fao_mapping_configs_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"fao"],[2,[7,"/"],[2,[6,"mapping_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/report/documents/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_report_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/report/documents(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_report_documents_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/report/signers/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_report_signer_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/report/signers(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_report_signers_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"signers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/shortlist/assessment_loads/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_shortlist_assessment_load_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"shortlist"],[2,[7,"/"],[2,[6,"assessment_loads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/shortlist/assessment_loads(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_shortlist_assessment_loads_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"shortlist"],[2,[7,"/"],[2,[6,"assessment_loads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/signers/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_signer_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/signers(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_signers_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"signers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/edges/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_workflow_edge_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"edges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/edges(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_workflow_edges_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"edges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/groups(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_workflow_groups_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/processes/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_workflow_process_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/processes(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_workflow_processes_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/requirements/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_workflow_requirement_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/requirement_stages/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_workflow_requirement_stage_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/requirement_stages(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_workflow_requirement_stages_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/requirements(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_workflow_requirements_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/stages/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_workflow_stage_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/stages(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abstract_workflow_stages_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"stages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/invitation/accept(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_user_invitation_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"invitation"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /calendar/work_schedules/:id/add_chilean_holidays(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_chilean_holidays_calendar_work_schedule_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"work_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_chilean_holidays"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/abstract_custom_fields/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_abstract_custom_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abstract_custom_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/abstract_entity_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_abstract_entity_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abstract_entity_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/abstract_entity_type_configs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_abstract_entity_type_config_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abstract_entity_type_configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/abstract_entity_type_configs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_abstract_entity_type_configs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abstract_entity_type_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/abstract_entity_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_abstract_entity_types_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abstract_entity_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_admin_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_admin_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_billing_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_billing_invoices_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/blog_posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_blog_post_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog_posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/blog_posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_blog_posts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/change_logs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_change_log_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"change_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/change_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_change_logs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"change_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_comment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_comments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/communication_channels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_communication_channel_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"communication_channels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/communication_channels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_communication_channels_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"communication_channels"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/compliance_contexts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_compliance_context_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"compliance_contexts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/compliance_contexts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_compliance_contexts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"compliance_contexts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_budgets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_budget_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_budgets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_budget_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_budget_template_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_budget_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_budget_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_budget_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_budget_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_budgets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_budgets_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_budgets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_leads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_lead_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_leads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_leads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_leads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_leads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_post_sale_interviews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_post_sale_interview_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_post_sale_interviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_post_sale_interviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_post_sale_interviews_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_post_sale_interviews"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_post_sale_tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_post_sale_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_post_sale_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_post_sale_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_post_sale_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_post_sale_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_pre_sale_interviews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_pre_sale_interview_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_pre_sale_interviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_pre_sale_interviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_pre_sale_interviews_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_pre_sale_interviews"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_pre_sale_tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_pre_sale_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_pre_sale_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_pre_sale_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_pre_sale_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_pre_sale_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_task_reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_task_report_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_task_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_task_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_task_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_task_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tech_tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_tech_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tech_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tech_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_tech_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tech_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tutorial_capsules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_tutorial_capsule_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tutorial_capsules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tutorial_capsules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_tutorial_capsules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tutorial_capsules"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tutorial_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_tutorial_template_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tutorial_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tutorial_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_tutorial_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tutorial_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tutorial_tours/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_tutorial_tour_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tutorial_tours"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tutorial_tours(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_crm_tutorial_tours_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tutorial_tours"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/customers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_customer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_onboarding_processes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_customer_onboarding_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_onboarding_processes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_onboarding_processes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_customer_onboarding_processes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_onboarding_processes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_service_suspensions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_customer_service_suspension_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_service_suspensions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_service_suspensions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_customer_service_suspensions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_service_suspensions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_customers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ecert_signature_certificates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ecert_signature_certificate_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ecert_signature_certificates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ecert_signature_certificates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ecert_signature_certificates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ecert_signature_certificates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_provider_inbound_events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_provider_inbound_event_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_provider_inbound_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_provider_inbound_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_provider_inbound_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_provider_inbound_events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_provider_outbound_deliveries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_provider_outbound_deliveries_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_provider_outbound_deliveries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_provider_outbound_deliveries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_provider_outbound_delivery_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_provider_outbound_deliveries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_provider_routing_domains/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_provider_routing_domain_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_provider_routing_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_provider_routing_domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_provider_routing_domains_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_provider_routing_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_provider_smtp_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_provider_smtp_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_provider_smtp_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_provider_smtp_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_provider_smtp_accounts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_provider_smtp_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/linode_object_storage_quota_configurations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_linode_object_storage_quota_configuration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"linode_object_storage_quota_configurations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/linode_object_storage_quota_configurations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_linode_object_storage_quota_configurations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"linode_object_storage_quota_configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/nps_records/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_nps_record_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nps_records"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/nps_records(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_nps_records_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nps_records"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/nps_results/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_nps_result_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nps_results"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/nps_results(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_nps_results_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nps_results"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/oauth_clients/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_oauth_client_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"oauth_clients"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/oauth_clients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_oauth_clients_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"oauth_clients"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_documentations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_page_documentation_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_documentations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_documentations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_page_documentations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_documentations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_product_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/roles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_role_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/roles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_roles_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_root_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/system_notifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_system_notification_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"system_notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/system_notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_system_notifications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"system_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/unsubscribed_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_unsubscribed_email_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"unsubscribed_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/unsubscribed_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_unsubscribed_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"unsubscribed_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /documents/analyze(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyze_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"analyze"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/docs/v1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_docs_v1_path = /*#__PURE__*/ __route({"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"v1"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/docs/v1/openapi(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_docs_v1_openapi_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"openapi"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/docs/v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_docs_v2_path = /*#__PURE__*/ __route({"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/docs/v2/arauco(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_docs_v2_arauco_path = /*#__PURE__*/ __route({"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"arauco"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/docs/v2/arauco/openapi(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_docs_v2_arauco_openapi_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"arauco"],[2,[7,"/"],[2,[6,"openapi"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/docs/v2/openapi(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_docs_v2_openapi_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"openapi"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/abstract/custom_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_abstract_custom_fields_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"custom_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/abstract/documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_abstract_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/abstract/document_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_abstract_document_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/abstract/document_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_abstract_document_types_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/abstract/documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_abstract_documents_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/abstract/entities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_abstract_entities_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"entities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/abstract/entities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_abstract_entity_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"entities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/abstract/entity_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_abstract_entity_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"entity_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/abstract/entity_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_abstract_entity_types_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"entity_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/castano/laboral/hiring_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_castano_laboral_hiring_documents_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"castano"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate/agreements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_corporate_agreement_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate/agreement_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_corporate_agreement_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreement_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate/agreement_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_corporate_agreement_documents_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreement_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate/agreements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_corporate_agreements_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate/branches/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_corporate_branch_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"branches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate/branches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_corporate_branches_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"branches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate/companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_corporate_companies_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate/companies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_corporate_company_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate/custom_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_corporate_custom_fields_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"custom_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate/document_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_corporate_document_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate/document_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_corporate_document_types_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/customer_billing_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_billing_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"customer_billing_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/customer_billing_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_billing_accounts_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"customer_billing_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/docx/templates/duoc/fill(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_docx_templates_duoc_fill_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"docx"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"duoc"],[2,[7,"/"],[2,[6,"fill"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/docx/templates/fill(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_docx_templates_fill_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"docx"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"fill"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/dt/record/integration/documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_dt_record_integration_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"record"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_groups_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/integra/laboral/employees/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_integra_laboral_employee_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"integra"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/integra/laboral/employees(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_integra_laboral_employees_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"integra"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/custom_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_laboral_custom_fields_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"custom_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/document_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_laboral_document_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/document_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_laboral_document_types_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/employees/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_laboral_employee_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/employees(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_laboral_employees_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/hirings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_laboral_hiring_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hirings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/hiring_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_laboral_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/hiring_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_laboral_hiring_documents_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/hirings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_laboral_hirings_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hirings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/security_layers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_laboral_security_layers_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"security_layers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/memberships/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_membership_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/memberships(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_memberships_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/webhook/amazon/ses/bounce_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_webhook_amazon_ses_bounce_subscriptions_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"webhook"],[2,[7,"/"],[2,[6,"amazon"],[2,[7,"/"],[2,[6,"ses"],[2,[7,"/"],[2,[6,"bounce_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/webhook/amazon/ses/complaint_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_webhook_amazon_ses_complaint_subscriptions_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"webhook"],[2,[7,"/"],[2,[6,"amazon"],[2,[7,"/"],[2,[6,"ses"],[2,[7,"/"],[2,[6,"complaint_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/webhook/crm/leads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_webhook_crm_leads_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"webhook"],[2,[7,"/"],[2,[6,"crm"],[2,[7,"/"],[2,[6,"leads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/arauco/laboral/employees/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_arauco_laboral_employee_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"arauco"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/arauco/laboral/employees(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_arauco_laboral_employees_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"arauco"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/arauco/laboral/hirings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_arauco_laboral_hiring_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"arauco"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hirings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/arauco/laboral/hiring_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_arauco_laboral_hiring_documents_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"arauco"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/arauco/laboral/hirings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_arauco_laboral_hirings_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"arauco"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hirings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/corporate/branches/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_corporate_branch_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"branches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/corporate/branches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_corporate_branches_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"branches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_groups_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/controldoc_form/templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_laboral_controldoc_form_templates_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/custom_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_laboral_custom_fields_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"custom_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/document_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_laboral_document_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/document_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_laboral_document_types_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/employees/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_laboral_employee_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/employees(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_laboral_employees_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/hirings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_laboral_hiring_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hirings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/hiring_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_laboral_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/hiring_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_laboral_hiring_documents_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/hirings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_laboral_hirings_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hirings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/security_layers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_laboral_security_layers_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"security_layers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/me/customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_me_customers_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/memberships/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_membership_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/memberships(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_memberships_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/oauth/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_oauth_authorize_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/oauth/introspect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_oauth_introspect_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"introspect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/oauth/revoke(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_oauth_revoke_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/oauth/token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_oauth_token_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/security_layers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_security_layers_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"security_layers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/controldoc_form/templates/:id/assign_mapping_links(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_mapping_links_abstract_controldoc_form_template_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_mapping_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/controldoc_form/templates/:id/assign_mapping_links(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_mapping_links_corporate_controldoc_form_template_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_mapping_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/controldoc_form/templates/:id/assign_mapping_links(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_mapping_links_laboral_controldoc_form_template_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_mapping_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/abstract/workflow/requirements/:customer_id/:process_id/:id/authenticate(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticate_public_abstract_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"authenticate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/delitos_economicos/denuncia/:customer_id/:process_id/:id/authenticate(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticate_public_economic_crime_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"delitos_economicos"],[2,[7,"/"],[2,[6,"denuncia"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"authenticate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/ley_karin/denuncia/:customer_id/:process_id/:id/authenticate(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticate_public_karin_law_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"ley_karin"],[2,[7,"/"],[2,[6,"denuncia"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"authenticate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/laboral/workflow/requirements/:customer_id/:process_id/:id/authenticate(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticate_public_laboral_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"authenticate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shared/entity_folder/check_list_shareds/:id/authenticate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticate_shared_entity_folder_check_list_shared_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shared"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_shareds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"authenticate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/abstract/workflow/requirements/:customer_id/:process_id/:id/authentication(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authentication_public_abstract_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"authentication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/delitos_economicos/denuncia/:customer_id/:process_id/:id/authentication(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authentication_public_economic_crime_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"delitos_economicos"],[2,[7,"/"],[2,[6,"denuncia"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"authentication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/ley_karin/denuncia/:customer_id/:process_id/:id/authentication(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authentication_public_karin_law_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"ley_karin"],[2,[7,"/"],[2,[6,"denuncia"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"authentication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/laboral/workflow/requirements/:customer_id/:process_id/:id/authentication(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authentication_public_laboral_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"authentication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shared/entity_folder/check_list_shareds/:id/authentication(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authentication_shared_entity_folder_check_list_shared_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shared"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_shareds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"authentication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/user_configurations/automatic_signature/disable(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const automatic_signature_disable_portal_user_configurations_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"user_configurations"],[2,[7,"/"],[2,[6,"automatic_signature"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/user_configurations/automatic_signature/enable(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const automatic_signature_enable_portal_user_configurations_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"user_configurations"],[2,[7,"/"],[2,[6,"automatic_signature"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/user_configurations/automatic_signature/management(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const automatic_signature_management_portal_user_configurations_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"user_configurations"],[2,[7,"/"],[2,[6,"automatic_signature"],[2,[7,"/"],[2,[6,"management"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/abstract_custom_fields/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_abstract_custom_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abstract_custom_fields"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/abstract_entity_type_configs/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_abstract_entity_type_configs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abstract_entity_type_configs"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/abstract_entity_types/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_abstract_entity_types_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abstract_entity_types"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_users/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_admin_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_users"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_invoices/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_billing_invoices_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_invoices"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/blog_posts/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_blog_posts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog_posts"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/change_logs/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_change_logs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"change_logs"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/communication_channels/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_communication_channels_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"communication_channels"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/compliance_contexts/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_compliance_contexts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"compliance_contexts"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_budget_templates/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_crm_budget_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_budget_templates"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_budgets/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_crm_budgets_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_budgets"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_leads/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_crm_leads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_leads"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_post_sale_interviews/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_crm_post_sale_interviews_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_post_sale_interviews"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_post_sale_tasks/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_crm_post_sale_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_post_sale_tasks"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_pre_sale_interviews/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_crm_pre_sale_interviews_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_pre_sale_interviews"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_pre_sale_tasks/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_crm_pre_sale_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_pre_sale_tasks"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_task_reports/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_crm_task_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_task_reports"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tech_tasks/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_crm_tech_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tech_tasks"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tutorial_capsules/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_crm_tutorial_capsules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tutorial_capsules"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tutorial_templates/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_crm_tutorial_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tutorial_templates"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tutorial_tours/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_crm_tutorial_tours_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tutorial_tours"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_onboarding_processes/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_customer_onboarding_processes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_onboarding_processes"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_service_suspensions/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_customer_service_suspensions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_service_suspensions"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customers/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_customers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ecert_signature_certificates/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_ecert_signature_certificates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ecert_signature_certificates"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_provider_inbound_events/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_email_provider_inbound_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_provider_inbound_events"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_provider_outbound_deliveries/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_email_provider_outbound_deliveries_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_provider_outbound_deliveries"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_provider_routing_domains/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_email_provider_routing_domains_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_provider_routing_domains"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_provider_smtp_accounts/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_email_provider_smtp_accounts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_provider_smtp_accounts"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/linode_object_storage_quota_configurations/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_linode_object_storage_quota_configurations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"linode_object_storage_quota_configurations"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/nps_records/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_nps_records_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nps_records"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/nps_results/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_nps_results_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nps_results"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/oauth_clients/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_oauth_clients_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"oauth_clients"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_documentations/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_page_documentations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_documentations"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/products/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/roles/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_roles_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/system_notifications/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_system_notifications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"system_notifications"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/unsubscribed_emails/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_unsubscribed_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"unsubscribed_emails"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_action_admin_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/mapping_fields/batch_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_update_dt_mapping_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"mapping_fields"],[2,[7,"/"],[2,[6,"batch_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billing/accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billing/quote/resources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_quote_resource_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"quote"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /billing/quotes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_quotes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"quotes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_path = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"blazer"]]);

/**
 * Generates rails route to
 * /blazer/queries/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_cancel_queries_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/checks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_check_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"checks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/checks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_checks_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"checks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /blazer/dashboards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_dashboard_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"dashboards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/dashboards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_dashboards_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"dashboards"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /blazer/queries/docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_docs_queries_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/checks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_edit_check_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /blazer/dashboards/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_edit_dashboard_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"dashboards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /blazer/queries/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_edit_query_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /blazer/checks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_new_check_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"checks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/dashboards/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_new_dashboard_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/queries/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_new_query_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_queries_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /blazer/queries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_query_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/dashboards/:id/refresh(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_refresh_dashboard_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"dashboards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /blazer/queries/:id/refresh(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_refresh_query_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /blazer/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_root_path = /*#__PURE__*/ __route({}, [2,[2,[7,"/"],[6,"blazer"]],[7,"/"]]);

/**
 * Generates rails route to
 * /blazer/checks/:id/run(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_run_check_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /blazer/queries/run(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_run_queries_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[6,"run"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/queries/schema(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_schema_queries_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[6,"schema"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/queries/tables(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_tables_queries_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[6,"tables"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/controldoc_form/documents/:id/block(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_abstract_controldoc_form_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"block"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/documents/:id/block(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_abstract_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"block"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/abstract/documents/:id/block(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_api_v1_abstract_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"block"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate/agreement_documents/:id/block(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_api_v1_corporate_agreement_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreement_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"block"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/hiring_documents/:id/block(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_api_v1_laboral_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"block"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/hiring_documents/:id/block(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_api_v2_laboral_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"block"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/agreement_documents/:id/block(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_corporate_agreement_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreement_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"block"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/controldoc_form/documents/:id/block(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_corporate_controldoc_form_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"block"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/controldoc_form/documents/:id/block(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_laboral_controldoc_form_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"block"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/employee_documents/:id/block(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_laboral_employee_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employee_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"block"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/hiring_documents/:id/block(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_laboral_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"block"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /blog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /blog/posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_post_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /blog/posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_posts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /public/crm/tutorial/tours/:id/budget_sent(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_sent_public_crm_tutorial_tour_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"crm"],[2,[7,"/"],[2,[6,"tutorial"],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"budget_sent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /bulk/datatable/distribution_list_filter/laborals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_datatable_distribution_list_filter_laboral_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"datatable"],[2,[7,"/"],[2,[6,"distribution_list_filter"],[2,[7,"/"],[2,[6,"laborals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /bulk/datatable/distribution_list_filter/laborals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_datatable_distribution_list_filter_laborals_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"datatable"],[2,[7,"/"],[2,[6,"distribution_list_filter"],[2,[7,"/"],[2,[6,"laborals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/sign_documents/bulk_rejection(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_rejection_portal_sign_documents_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"sign_documents"],[2,[7,"/"],[2,[6,"bulk_rejection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/sign_documents/bulk_sign(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_sign_portal_sign_documents_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"sign_documents"],[2,[7,"/"],[2,[6,"bulk_sign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /calendar/work_schedules/:calendar_id/holiday_events/:id(.:format)
 * @param {any} calendar_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendar_holiday_event_path = /*#__PURE__*/ __route({"calendar_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"work_schedules"],[2,[7,"/"],[2,[3,"calendar_id"],[2,[7,"/"],[2,[6,"holiday_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /calendar/work_schedules/:calendar_id/holiday_events(.:format)
 * @param {any} calendar_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendar_holiday_events_path = /*#__PURE__*/ __route({"calendar_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"work_schedules"],[2,[7,"/"],[2,[3,"calendar_id"],[2,[7,"/"],[2,[6,"holiday_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /calendar/work_schedules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendar_work_schedule_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"work_schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /calendar/work_schedules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendar_work_schedules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"work_schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /canal-de-denuncias(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const canal_de_denuncias_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"canal-de-denuncias"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /changelogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changelog_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"changelogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /changelogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changelogs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"changelogs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entities/clone/:id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_abstract_entities_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entities"],[2,[7,"/"],[2,[6,"clone"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_list_requirements/:id/clone(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_abstract_entity_folder_check_list_requirement_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_requirements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shared/entity_folder/check_list_shareds/:id/requirement/:folder_id/clone/:requirement_id(.:format)
 * @param {any} id
 * @param {any} folder_id
 * @param {any} requirement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_requirement_shared_entity_folder_check_list_shared_path = /*#__PURE__*/ __route({"id":{"r":true},"folder_id":{"r":true},"requirement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shared"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_shareds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"requirement"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"clone"],[2,[7,"/"],[2,[3,"requirement_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /comment/versioner/document/items/:resource_id(.:format)
 * @param {any} resource_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comment_versioner_document_items_path = /*#__PURE__*/ __route({"resource_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comment"],[2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"resource_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /comment/workflow/requirements/:resource_id(.:format)
 * @param {any} resource_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comment_workflow_requirements_path = /*#__PURE__*/ __route({"resource_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comment"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"resource_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /como-usarlo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const como_usarlo_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"como-usarlo"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/controldoc_form/documents/:id/complete(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_portal_controldoc_form_document_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/tasks/:id/completed(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completed_compliance_task_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"completed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/activities(.:format)
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_activities_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/activities/:id(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_activity_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/activity_containers/:id(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_activity_container_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"activity_containers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/activity_containers(.:format)
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_activity_containers_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"activity_containers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/activities/:activity_id/evidence_loads(.:format)
 * @param {any} compliance_context_id
 * @param {any} activity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_activity_evidence_loads_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"activity_id"],[2,[7,"/"],[2,[6,"evidence_loads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/bulk/load/activities(.:format)
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_bulk_load_activities_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/bulk/load/activities/:id(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_bulk_load_activity_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/bulk/load/activity_items(.:format)
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_bulk_load_activity_items_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"activity_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/custom_fields/:id(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_custom_field_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/custom_fields(.:format)
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_custom_fields_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"custom_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/dashboards(.:format)
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_dashboards_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"dashboards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/evidences/:id(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_evidence_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"evidences"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/evidence_loads/:id(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_evidence_load_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"evidence_loads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/evidences(.:format)
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_evidences_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"evidences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/groups/:id(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_group_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/groups(.:format)
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_groups_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance-municipios/canal-de-denuncias/delitos-economicos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_municipios_canal_de_denuncias_delitos_economicos_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"compliance-municipios"],[2,[7,"/"],[2,[6,"canal-de-denuncias"],[2,[7,"/"],[2,[6,"delitos-economicos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance-municipios/canal-de-denuncias/ley-karin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_municipios_canal_de_denuncias_ley_karin_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"compliance-municipios"],[2,[7,"/"],[2,[6,"canal-de-denuncias"],[2,[7,"/"],[2,[6,"ley-karin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance-municipios/capacitacion-ley-karin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_municipios_capacitacion_ley_karin_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"compliance-municipios"],[2,[7,"/"],[2,[6,"capacitacion-ley-karin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /compliance-municipios-chile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_municipios_chile_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"compliance-municipios-chile"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/risk_levels/:id(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_risk_level_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"risk_levels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/risk_levels(.:format)
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_risk_levels_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"risk_levels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/tasks/:id(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_task_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/tasks(.:format)
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_tasks_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/requirements/:id/confirm_destroy(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_destroy_abstract_workflow_requirement_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/risk_levels/:id/confirm_destroy(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_destroy_compliance_risk_level_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"risk_levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/requirements/:id/confirm_destroy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_destroy_economic_crime_workflow_requirement_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/requirements/:id/confirm_destroy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_destroy_karin_law_workflow_requirement_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/requirements/:id/confirm_destroy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_destroy_laboral_workflow_requirement_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/sessions/confirm/:user_id/:token(.:format)
 * @param {any} tenant
 * @param {any} user_id
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_email_portal_sessions_path = /*#__PURE__*/ __route({"tenant":{"r":true},"user_id":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"confirm"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/employee_email_changes/confirm(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_portal_employee_email_changes_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"employee_email_changes"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /contacto(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contacto_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"contacto"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /controldoc/ai/chat_conversations/:chat_conversation_id/chat_messages(.:format)
 * @param {any} chat_conversation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const controldoc_ai_chat_conversation_chat_messages_path = /*#__PURE__*/ __route({"chat_conversation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"controldoc"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"chat_conversations"],[2,[7,"/"],[2,[3,"chat_conversation_id"],[2,[7,"/"],[2,[6,"chat_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /controldoc/ai/chat_conversations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const controldoc_ai_chat_conversations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"controldoc"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"chat_conversations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/document/callbacks/:document_id/controldoc(.:format)
 * @param {any} document_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const controldoc_api_v1_document_callback_path = /*#__PURE__*/ __route({"document_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"callbacks"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[2,[6,"controldoc"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/agreements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_agreement_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/agreement_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_agreement_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreement_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/agreement_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_agreement_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreement_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /corporate/agreements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_agreements_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreements"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /corporate/bulk/notification/signs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_bulk_notification_sign_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[6,"signs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/bulk/notification/signs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_bulk_notification_signs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[6,"signs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/bulk/request/agreement_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_bulk_request_agreement_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"agreement_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/bulk/request/agreement_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_bulk_request_agreement_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"agreement_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/bulk/request/agreement_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_bulk_request_agreement_item_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"agreement_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/bulk/request/zip/documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_bulk_request_zip_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/bulk/request/zip/documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_bulk_request_zip_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/check_list/agreement_processes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_check_list_agreement_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"agreement_processes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/check_list/agreement_processes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_check_list_agreement_processes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"agreement_processes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/check_list/agreement_tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_check_list_agreement_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"agreement_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/check_list/agreement_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_check_list_agreement_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"agreement_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_companies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /corporate/companies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_company_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/controldoc_form/documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_controldoc_form_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/controldoc_form/documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_controldoc_form_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/controldoc_form/templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_controldoc_form_template_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/controldoc_form/template_layouts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_controldoc_form_template_layout_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"template_layouts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/controldoc_form/template_layouts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_controldoc_form_template_layouts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"template_layouts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/controldoc_form/templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_controldoc_form_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/custom_fields/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_custom_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/custom_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_custom_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"custom_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /corporate/document_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_document_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/document_type_batteries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_document_type_batteries_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"document_type_batteries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /corporate/document_type_batteries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_document_type_battery_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"document_type_batteries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/document_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_document_types_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /corporate/signers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_signer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/signers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_signers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"signers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /corporativo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporativo_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporativo"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/hiring_documents/create_by_identifier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_by_identifier_api_v1_laboral_hiring_documents_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[6,"create_by_identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/hiring_documents/create_by_identifier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_by_identifier_api_v2_laboral_hiring_documents_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[6,"create_by_identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/hiring_documents/create_by_identifier_middleware(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_by_identifier_middleware_api_v1_laboral_hiring_documents_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[6,"create_by_identifier_middleware"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/laboral/hiring/integrations/:hiring_id(.:format)
 * @param {any} hiring_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_dt_laboral_hiring_integrations_path = /*#__PURE__*/ __route({"hiring_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"hiring_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shared/entity_folder/check_list_shareds/:id/requirement/:folder_id(.:format)
 * @param {any} id
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_requirement_shared_entity_folder_check_list_shared_path = /*#__PURE__*/ __route({"id":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shared"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_shareds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"requirement"],[2,[7,"/"],[2,[3,"folder_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/abstract/workflow/requirements/:customer_id/:process_id/:id/created(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const created_public_abstract_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"created"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/delitos_economicos/denuncia/:customer_id/:process_id/:id/created(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const created_public_economic_crime_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"delitos_economicos"],[2,[7,"/"],[2,[6,"denuncia"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"created"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/ley_karin/denuncia/:customer_id/:process_id/:id/created(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const created_public_karin_law_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"ley_karin"],[2,[7,"/"],[2,[6,"denuncia"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"created"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/laboral/workflow/requirements/:customer_id/:process_id/:id/created(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const created_public_laboral_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"created"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cumplimiento(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cumplimiento_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"cumplimiento"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/billing/quote/ecert_enrolled/cumulative(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cumulative_api_v1_billing_quote_ecert_enrolled_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"quote"],[2,[7,"/"],[2,[6,"ecert_enrolled"],[2,[7,"/"],[2,[6,"cumulative"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/billing/quote/ecert_single_use/cumulative(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cumulative_api_v1_billing_quote_ecert_single_use_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"quote"],[2,[7,"/"],[2,[6,"ecert_single_use"],[2,[7,"/"],[2,[6,"cumulative"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/billing/quote/signature_certificate/cumulative(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cumulative_api_v1_billing_quote_signature_certificate_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"quote"],[2,[7,"/"],[2,[6,"signature_certificate"],[2,[7,"/"],[2,[6,"cumulative"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/billing/quote/simple_signature/cumulative(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cumulative_api_v1_billing_quote_simple_signature_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"quote"],[2,[7,"/"],[2,[6,"simple_signature"],[2,[7,"/"],[2,[6,"cumulative"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customer_onboarding_processes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customer_onboarding_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_onboarding_processes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orgs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /default_signers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const default_signer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"default_signers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /default_signers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const default_signers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"default_signers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_admin_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/versioner/document/comparisons/:id/diff_current_file(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const diff_current_file_portal_versioner_document_comparison_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{"d":"pdf"}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diff_current_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /versioner/document/comparisons/:id/diff_current_file(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const diff_current_file_versioner_document_comparison_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"pdf"}}, [2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diff_current_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/versioner/document/comparisons/:id/diff_previous_file(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const diff_previous_file_portal_versioner_document_comparison_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{"d":"pdf"}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diff_previous_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /versioner/document/comparisons/:id/diff_previous_file(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const diff_previous_file_versioner_document_comparison_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"pdf"}}, [2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diff_previous_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /direct_links/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const direct_link_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"direct_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /direct_links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const direct_links_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"direct_links"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/default_signers/disable_automatic_signature(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_automatic_signature_portal_default_signers_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"default_signers"],[2,[7,"/"],[2,[6,"disable_automatic_signature"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /profiles/disable_custom_pin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_custom_pin_profiles_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[6,"disable_custom_pin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profiles/disable_dynamic_pin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_dynamic_pin_profiles_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[6,"disable_dynamic_pin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/documents/:id/dispatch_notification_subscriber_request/:notification_subscriber_id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {any} notification_subscriber_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dispatch_notification_subscriber_request_abstract_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"notification_subscriber_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dispatch_notification_subscriber_request"],[2,[7,"/"],[2,[3,"notification_subscriber_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/agreement_documents/:id/dispatch_notification_subscriber_request/:notification_subscriber_id(.:format)
 * @param {any} id
 * @param {any} notification_subscriber_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dispatch_notification_subscriber_request_corporate_agreement_document_path = /*#__PURE__*/ __route({"id":{"r":true},"notification_subscriber_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreement_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dispatch_notification_subscriber_request"],[2,[7,"/"],[2,[3,"notification_subscriber_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/hiring_documents/:id/dispatch_notification_subscriber_request/:notification_subscriber_id(.:format)
 * @param {any} id
 * @param {any} notification_subscriber_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dispatch_notification_subscriber_request_laboral_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"notification_subscriber_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dispatch_notification_subscriber_request"],[2,[7,"/"],[2,[3,"notification_subscriber_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/load/entities/:id/download(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_abstract_bulk_load_entity_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"entities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/request/zip/documents/:id/download/:attachment_id(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_abstract_bulk_request_zip_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/controldoc_form/templates/:id/download(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_abstract_controldoc_form_template_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/documents/:id/download(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_abstract_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entities/:id/download(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_abstract_entity_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/nps_records/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_admin_nps_record_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nps_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /comment/versioner/document/items/:resource_id/:id/download/:attach_id(.:format)
 * @param {any} resource_id
 * @param {any} id
 * @param {any} attach_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_attach_comment_versioner_document_item_path = /*#__PURE__*/ __route({"resource_id":{"r":true},"id":{"r":true},"attach_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comment"],[2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"attach_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /comment/workflow/requirements/:resource_id/:id/download/:attach_id(.:format)
 * @param {any} resource_id
 * @param {any} id
 * @param {any} attach_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_attach_comment_workflow_requirement_path = /*#__PURE__*/ __route({"resource_id":{"r":true},"id":{"r":true},"attach_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comment"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"attach_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/comment/versioner/document/items/:resource_id/:id/download/:attach_id(.:format)
 * @param {any} tenant
 * @param {any} resource_id
 * @param {any} id
 * @param {any} attach_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_attach_portal_comment_versioner_document_item_path = /*#__PURE__*/ __route({"tenant":{"r":true},"resource_id":{"r":true},"id":{"r":true},"attach_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"comment"],[2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"attach_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/comment/workflow/requirements/:resource_id/:id/download/:attach_id(.:format)
 * @param {any} tenant
 * @param {any} resource_id
 * @param {any} id
 * @param {any} attach_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_attach_portal_comment_workflow_requirement_path = /*#__PURE__*/ __route({"tenant":{"r":true},"resource_id":{"r":true},"id":{"r":true},"attach_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"comment"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"attach_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/comment/workflow/requirements/:resource_id/:customer_id/:id/download/:attach_id(.:format)
 * @param {any} resource_id
 * @param {any} customer_id
 * @param {any} id
 * @param {any} attach_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_attach_public_comment_workflow_requirement_path = /*#__PURE__*/ __route({"resource_id":{"r":true},"customer_id":{"r":true},"id":{"r":true},"attach_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"comment"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"attach_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/abstract/documents/:id/download_base64(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_base64_api_v1_abstract_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_base64"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate/agreement_documents/:id/download_base64(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_base64_api_v1_corporate_agreement_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreement_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_base64"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/hiring_documents/:id/download_base64(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_base64_api_v1_laboral_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_base64"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/hiring_documents/:id/download_base64(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_base64_api_v2_laboral_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_base64"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/evidence_files/:id/download(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_compliance_evidence_file_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"evidence_files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/agreements/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_corporate_agreement_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/agreement_documents/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_corporate_agreement_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreement_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/bulk/request/zip/documents/:id/download/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_corporate_bulk_request_zip_document_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/controldoc_form/templates/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_corporate_controldoc_form_template_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_onboarding_processes/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_customer_onboarding_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_onboarding_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/arauco/docx_merge_fields/:id/download_data_file(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_data_file_laboral_bulk_load_arauco_docx_merge_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"arauco"],[2,[7,"/"],[2,[6,"docx_merge_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_data_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shared/entity_folder/check_list_shareds/:id/task/:task_id/download_document(.:format)
 * @param {any} id
 * @param {any} task_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_document_shared_entity_folder_check_list_shared_path = /*#__PURE__*/ __route({"id":{"r":true},"task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shared"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_shareds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"download_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/load/entities/download_example(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_example_abstract_bulk_load_entities_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"entities"],[2,[7,"/"],[2,[6,"download_example"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/employees/download_example(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_example_laboral_bulk_load_employees_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"download_example"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/hirings/download_example(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_example_laboral_bulk_load_hirings_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"hirings"],[2,[7,"/"],[2,[6,"download_example"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_list_tasks/:id/download_file(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_file_abstract_entity_folder_check_list_task_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/arauco/docx_merge_field_items/:id/download_file(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_file_laboral_bulk_load_arauco_docx_merge_field_item_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"arauco"],[2,[7,"/"],[2,[6,"docx_merge_field_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shared/entity_folder/check_list_shareds/:id/task/:task_id/download_file(.:format)
 * @param {any} id
 * @param {any} task_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_file_shared_entity_folder_check_list_shared_path = /*#__PURE__*/ __route({"id":{"r":true},"task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shared"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_shareds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"download_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shared/entity_folder/check_list_tasks/:id/download_file(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_file_shared_entity_folder_check_list_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shared"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /billing/quote/resources/:id/download_google_drive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_google_drive_billing_quote_resource_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"quote"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_google_drive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/requirement_stages/:id/download/:file_item_id/input/file_item(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_input_file_item_abstract_workflow_requirement_stage_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"input"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/requirement_stages/:id/download/:file_item_id/input/file_item(.:format)
 * @param {any} id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_input_file_item_economic_crime_workflow_requirement_stage_path = /*#__PURE__*/ __route({"id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"input"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/requirement_stages/:id/download/:file_item_id/input/file_item(.:format)
 * @param {any} id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_input_file_item_karin_law_workflow_requirement_stage_path = /*#__PURE__*/ __route({"id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"input"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/requirement_stages/:id/download/:file_item_id/input/file_item(.:format)
 * @param {any} id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_input_file_item_laboral_workflow_requirement_stage_path = /*#__PURE__*/ __route({"id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"input"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/abstract/workflow/requirement_stages/:id/download/:file_item_id/input/file_item(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_input_file_item_portal_abstract_workflow_requirement_stage_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"input"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/economic_crime/workflow/requirement_stages/:id/download/:file_item_id/input/file_item(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_input_file_item_portal_economic_crime_workflow_requirement_stage_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"input"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/karin_law/workflow/requirement_stages/:id/download/:file_item_id/input/file_item(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_input_file_item_portal_karin_law_workflow_requirement_stage_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"input"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/laboral/workflow/requirement_stages/:id/download/:file_item_id/input/file_item(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_input_file_item_portal_laboral_workflow_requirement_stage_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"input"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/abstract/workflow/requirements/:customer_id/:process_id/:id/:requirement_stage_id/download/:file_item_id/input/file_item(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {any} requirement_stage_id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_input_file_item_public_abstract_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"requirement_stage_id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"requirement_stage_id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"input"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/delitos_economicos/denuncia/:customer_id/:process_id/:id/:requirement_stage_id/download/:file_item_id/input/file_item(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {any} requirement_stage_id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_input_file_item_public_economic_crime_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"requirement_stage_id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"delitos_economicos"],[2,[7,"/"],[2,[6,"denuncia"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"requirement_stage_id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"input"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/ley_karin/denuncia/:customer_id/:process_id/:id/:requirement_stage_id/download/:file_item_id/input/file_item(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {any} requirement_stage_id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_input_file_item_public_karin_law_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"requirement_stage_id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"ley_karin"],[2,[7,"/"],[2,[6,"denuncia"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"requirement_stage_id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"input"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/laboral/workflow/requirements/:customer_id/:process_id/:id/:requirement_stage_id/download/:file_item_id/input/file_item(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {any} requirement_stage_id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_input_file_item_public_laboral_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"requirement_stage_id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"requirement_stage_id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"input"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/employees/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_laboral_bulk_load_employee_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/hirings/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_laboral_bulk_load_hiring_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"hirings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/request/zip/documents/:id/download/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_laboral_bulk_request_zip_document_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/controldoc_form/templates/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_laboral_controldoc_form_template_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/employees/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_laboral_employee_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/employee_documents/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_laboral_employee_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employee_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/hirings/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_laboral_hiring_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hirings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/hiring_documents/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_laboral_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/requirement_stages/:id/download/:file_item_id/output/file_item(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_output_file_item_abstract_workflow_requirement_stage_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"output"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/requirement_stages/:id/download/:file_item_id/output/file_item(.:format)
 * @param {any} id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_output_file_item_economic_crime_workflow_requirement_stage_path = /*#__PURE__*/ __route({"id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"output"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/requirement_stages/:id/download/:file_item_id/output/file_item(.:format)
 * @param {any} id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_output_file_item_karin_law_workflow_requirement_stage_path = /*#__PURE__*/ __route({"id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"output"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/requirement_stages/:id/download/:file_item_id/output/file_item(.:format)
 * @param {any} id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_output_file_item_laboral_workflow_requirement_stage_path = /*#__PURE__*/ __route({"id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"output"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/abstract/workflow/requirement_stages/:id/download/:file_item_id/output/file_item(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_output_file_item_portal_abstract_workflow_requirement_stage_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"output"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/economic_crime/workflow/requirement_stages/:id/download/:file_item_id/output/file_item(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_output_file_item_portal_economic_crime_workflow_requirement_stage_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"output"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/karin_law/workflow/requirement_stages/:id/download/:file_item_id/output/file_item(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_output_file_item_portal_karin_law_workflow_requirement_stage_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"output"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/laboral/workflow/requirement_stages/:id/download/:file_item_id/output/file_item(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_output_file_item_portal_laboral_workflow_requirement_stage_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"output"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/abstract/workflow/requirements/:customer_id/:process_id/:id/:requirement_stage_id/download/:file_item_id/output/file_item(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {any} requirement_stage_id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_output_file_item_public_abstract_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"requirement_stage_id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"requirement_stage_id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"output"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/delitos_economicos/denuncia/:customer_id/:process_id/:id/:requirement_stage_id/download/:file_item_id/output/file_item(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {any} requirement_stage_id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_output_file_item_public_economic_crime_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"requirement_stage_id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"delitos_economicos"],[2,[7,"/"],[2,[6,"denuncia"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"requirement_stage_id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"output"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/ley_karin/denuncia/:customer_id/:process_id/:id/:requirement_stage_id/download/:file_item_id/output/file_item(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {any} requirement_stage_id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_output_file_item_public_karin_law_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"requirement_stage_id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"ley_karin"],[2,[7,"/"],[2,[6,"denuncia"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"requirement_stage_id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"output"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/laboral/workflow/requirements/:customer_id/:process_id/:id/:requirement_stage_id/download/:file_item_id/output/file_item(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {any} requirement_stage_id
 * @param {any} file_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_output_file_item_public_laboral_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"requirement_stage_id":{"r":true},"file_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"requirement_stage_id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"file_item_id"],[2,[7,"/"],[2,[6,"output"],[2,[7,"/"],[2,[6,"file_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/compliance/:compliance_context_id/evidence_files/:id/download(.:format)
 * @param {any} tenant
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_portal_compliance_evidence_file_path = /*#__PURE__*/ __route({"tenant":{"r":true},"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"evidence_files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/documents/:id/download(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_portal_document_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/sign_documents/:id/download(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_portal_sign_document_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"sign_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/tasks/:id/download/:task_document_id(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {any} task_document_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_task_document_compliance_task_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"task_document_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"task_document_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_list_requirements/:id/download_template(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_template_abstract_entity_folder_check_list_requirement_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_requirements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/bulk/load/annexe_records/download_template(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_template_dt_bulk_load_annexe_records_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"annexe_records"],[2,[7,"/"],[2,[6,"download_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/bulk/load/contract_records/download_template(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_template_dt_bulk_load_contract_records_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"contract_records"],[2,[7,"/"],[2,[6,"download_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/arauco/docx_merge_fields/:id/download_template_file(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_template_file_laboral_bulk_load_arauco_docx_merge_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"arauco"],[2,[7,"/"],[2,[6,"docx_merge_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_template_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shared/entity_folder/check_list_shareds/:id/requirement/:folder_id/download_template/:requirement_id(.:format)
 * @param {any} id
 * @param {any} folder_id
 * @param {any} requirement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_template_requirement_shared_entity_folder_check_list_shared_path = /*#__PURE__*/ __route({"id":{"r":true},"folder_id":{"r":true},"requirement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shared"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_shareds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"requirement"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"download_template"],[2,[7,"/"],[2,[3,"requirement_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/bulk/load/activities/:id/download_upload_file(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_upload_file_compliance_bulk_load_activity_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_upload_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/dt/record/integration/documents/:id/download_voucher(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_voucher_api_v1_dt_record_integration_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"record"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_voucher"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/record/integrations/:id/download_voucher_file(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_voucher_file_dt_record_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"record"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_voucher_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/processes/:id/draft(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draft_abstract_workflow_process_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/processes/:id/draft(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draft_economic_crime_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/processes/:id/draft(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draft_karin_law_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/processes/:id/draft(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draft_laboral_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/bulk/load/annexe_records/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dt_bulk_load_annexe_record_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"annexe_records"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/bulk/load/annexe_records(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dt_bulk_load_annexe_records_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"annexe_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/bulk/load/contract_records/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dt_bulk_load_contract_record_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"contract_records"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/bulk/load/contract_records(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dt_bulk_load_contract_records_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"contract_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/laboral/hiring/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dt_laboral_hiring_integrations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/mapping_fields/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dt_mapping_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"mapping_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/mapping_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dt_mapping_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"mapping_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dt/record/integrations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dt_record_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"record"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/record/integrations/:integration_id/info(.:format)
 * @param {any} integration_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dt_record_integration_info_path = /*#__PURE__*/ __route({"integration_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"record"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_id"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/setting/fetch_dt_info_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dt_setting_fetch_dt_info_request_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"setting"],[2,[7,"/"],[2,[6,"fetch_dt_info_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/setting/fetch_dt_info_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dt_setting_fetch_dt_info_requests_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"setting"],[2,[7,"/"],[2,[6,"fetch_dt_info_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/requirements/:id/ebook(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ebook_abstract_workflow_requirement_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ebook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/requirements/:id/ebook(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ebook_economic_crime_workflow_requirement_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ebook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/requirements/:id/ebook(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ebook_karin_law_workflow_requirement_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ebook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/requirements/:id/ebook(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ebook_laboral_workflow_requirement_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ebook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/abstract/workflow/requirements/:id/ebook(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ebook_portal_abstract_workflow_requirement_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ebook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/economic_crime/workflow/requirements/:id/ebook(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ebook_portal_economic_crime_workflow_requirement_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ebook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/laboral/workflow/requirements/:id/ebook(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ebook_portal_laboral_workflow_requirement_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ebook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecert/documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecert_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecert"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecert/signature_certificates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecert_signature_certificate_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecert"],[2,[7,"/"],[2,[6,"signature_certificates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecert/signature_certificates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecert_signature_certificates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"ecert"],[2,[7,"/"],[2,[6,"signature_certificates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/edges/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const economic_crime_workflow_edge_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"edges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/edges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const economic_crime_workflow_edges_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"edges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const economic_crime_workflow_groups_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/processes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const economic_crime_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/processes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const economic_crime_workflow_processes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/requirements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const economic_crime_workflow_requirement_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/requirement_stages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const economic_crime_workflow_requirement_stage_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/requirements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const economic_crime_workflow_requirements_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/stages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const economic_crime_workflow_stage_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/stages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const economic_crime_workflow_stages_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"stages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/load/documents/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_bulk_load_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/load/entities/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_bulk_load_entity_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"entities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/notification/signs/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_bulk_notification_sign_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[6,"signs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/request/zip/documents/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_bulk_request_zip_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/check_list/processes/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_check_list_process_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/check_list/tasks/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_check_list_task_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/controldoc_form/templates/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_controldoc_form_template_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/controldoc_form/template_layouts/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_controldoc_form_template_layout_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"template_layouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/custom_fields/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_custom_field_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/documents/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/document_types/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_document_type_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/document_type_batteries/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_document_type_battery_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"document_type_batteries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entities/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_entity_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_lists/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_entity_folder_check_list_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_list_shareds/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_entity_folder_check_list_shared_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_shareds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_list_tasks/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_entity_folder_check_list_task_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/fao/mapping_configs/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_fao_mapping_config_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"fao"],[2,[7,"/"],[2,[6,"mapping_configs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/signers/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_signer_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/processes/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_workflow_process_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/requirement_stages/:id/edit(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_abstract_workflow_requirement_stage_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/abstract_entity_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_abstract_entity_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abstract_entity_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/abstract_entity_type_configs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_abstract_entity_type_config_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abstract_entity_type_configs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_admin_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/blog_posts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_blog_post_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog_posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/change_logs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_change_log_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"change_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/compliance_contexts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_compliance_context_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"compliance_contexts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_budgets/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_crm_budget_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_budgets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_budget_templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_crm_budget_template_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_budget_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_post_sale_interviews/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_crm_post_sale_interview_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_post_sale_interviews"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_post_sale_tasks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_crm_post_sale_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_post_sale_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_pre_sale_interviews/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_crm_pre_sale_interview_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_pre_sale_interviews"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_pre_sale_tasks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_crm_pre_sale_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_pre_sale_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_task_reports/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_crm_task_report_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_task_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tech_tasks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_crm_tech_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tech_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tutorial_capsules/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_crm_tutorial_capsule_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tutorial_capsules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tutorial_templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_crm_tutorial_template_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tutorial_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tutorial_tours/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_crm_tutorial_tour_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tutorial_tours"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_customer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_onboarding_processes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_customer_onboarding_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_onboarding_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_service_suspensions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_customer_service_suspension_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_service_suspensions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ecert_signature_certificates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_ecert_signature_certificate_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ecert_signature_certificates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_provider_routing_domains/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_email_provider_routing_domain_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_provider_routing_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_provider_smtp_accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_email_provider_smtp_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_provider_smtp_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/linode_object_storage_quota_configurations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_linode_object_storage_quota_configuration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"linode_object_storage_quota_configurations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/nps_records/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_nps_record_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nps_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/nps_results/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_nps_result_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nps_results"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/oauth_clients/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_oauth_client_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"oauth_clients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_documentations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_page_documentation_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_documentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/products/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_product_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/roles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_role_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/system_notifications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_system_notification_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"system_notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/hiring_documents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_laboral_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/hiring_documents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v2_laboral_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /billing/accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_billing_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /blog/posts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_blog_post_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /calendar/work_schedules/:calendar_id/holiday_events/:id/edit(.:format)
 * @param {any} calendar_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_calendar_holiday_event_path = /*#__PURE__*/ __route({"calendar_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"work_schedules"],[2,[7,"/"],[2,[3,"calendar_id"],[2,[7,"/"],[2,[6,"holiday_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /calendar/work_schedules/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_calendar_work_schedule_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"work_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/activities/:id/edit(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_compliance_activity_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/bulk/load/activities/:id/edit(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_compliance_bulk_load_activity_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/custom_fields/:id/edit(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_compliance_custom_field_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/evidence_files/:id/edit(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_compliance_evidence_file_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"evidence_files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/evidence_loads/:id/edit(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_compliance_evidence_load_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"evidence_loads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/groups/:id/edit(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_compliance_group_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/risk_levels/:id/edit(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_compliance_risk_level_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"risk_levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/tasks/:id/edit(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_compliance_task_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/agreements/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_corporate_agreement_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/agreement_documents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_corporate_agreement_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreement_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/bulk/notification/signs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_corporate_bulk_notification_sign_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[6,"signs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/bulk/request/zip/documents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_corporate_bulk_request_zip_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/check_list/agreement_processes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_corporate_check_list_agreement_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"agreement_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/check_list/agreement_tasks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_corporate_check_list_agreement_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"agreement_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/companies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_corporate_company_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/controldoc_form/templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_corporate_controldoc_form_template_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/controldoc_form/template_layouts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_corporate_controldoc_form_template_layout_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"template_layouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/custom_fields/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_corporate_custom_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/document_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_corporate_document_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/document_type_batteries/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_corporate_document_type_battery_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"document_type_batteries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/signers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_corporate_signer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_customer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /default_signers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_default_signer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"default_signers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/mapping_fields/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_dt_mapping_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"mapping_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/record/integrations/:integration_id/info/edit(.:format)
 * @param {any} integration_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_dt_record_integration_info_path = /*#__PURE__*/ __route({"integration_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"record"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_id"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/setting/fetch_dt_info_requests/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_dt_setting_fetch_dt_info_request_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"setting"],[2,[7,"/"],[2,[6,"fetch_dt_info_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecert/signature_certificates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_ecert_signature_certificate_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecert"],[2,[7,"/"],[2,[6,"signature_certificates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/processes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_economic_crime_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_group_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/complaints/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_karin_law_complaint_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"complaints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/custom_fields/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_karin_law_custom_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/document_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_karin_law_document_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/processes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_karin_law_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/employees/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_bulk_load_employee_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/hirings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_bulk_load_hiring_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"hirings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/hiring_documents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_bulk_load_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/my_filters/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_bulk_my_filter_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"my_filters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/request/zip/documents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_bulk_request_zip_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/check_list/hiring_processes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_check_list_hiring_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"hiring_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/check_list/hiring_tasks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_check_list_hiring_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"hiring_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/controldoc_form/templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_controldoc_form_template_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/controldoc_form/template_layouts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_controldoc_form_template_layout_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"template_layouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/custom_fields/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_custom_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/document_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_document_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/document_type_batteries/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_document_type_battery_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"document_type_batteries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/employees/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_employee_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/employee_documents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_employee_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employee_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/hirings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_hiring_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hirings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/hiring_documents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/shortlist/mapping_configs/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_shortlist_mapping_configs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"shortlist"],[2,[7,"/"],[2,[6,"mapping_configs"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/signers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_signer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/processes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laboral_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /memberships/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_membership_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/compliance/:compliance_context_id/activities/:id/edit(.:format)
 * @param {any} tenant
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_portal_compliance_activity_path = /*#__PURE__*/ __route({"tenant":{"r":true},"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/compliance/:compliance_context_id/evidence_files/:id/edit(.:format)
 * @param {any} tenant
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_portal_compliance_evidence_file_path = /*#__PURE__*/ __route({"tenant":{"r":true},"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"evidence_files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/compliance/:compliance_context_id/evidence_loads/:id/edit(.:format)
 * @param {any} tenant
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_portal_compliance_evidence_load_path = /*#__PURE__*/ __route({"tenant":{"r":true},"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"evidence_loads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /portal/configurations/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_portal_configurations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"configurations"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/custom_pins/edit(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_portal_custom_pins_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"custom_pins"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/profiles/edit(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_portal_profiles_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/versioner/document/threads/:id/edit(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_portal_versioner_document_thread_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/versioner/document/threads/:thread_id/items/:id/edit(.:format)
 * @param {any} tenant
 * @param {any} thread_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_portal_versioner_document_thread_item_path = /*#__PURE__*/ __route({"tenant":{"r":true},"thread_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"thread_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /profiles/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_profiles_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security_layers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_security_layer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security_layers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /signers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_signer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /versioner/document/threads/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_versioner_document_thread_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /versioner/document/threads/:thread_id/items/:id/edit(.:format)
 * @param {any} thread_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_versioner_document_thread_item_path = /*#__PURE__*/ __route({"thread_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"thread_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /elige-controldoc(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const elige_controldoc_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"elige-controldoc"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/default_signers/enable_automatic_signature(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_automatic_signature_portal_default_signers_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"default_signers"],[2,[7,"/"],[2,[6,"enable_automatic_signature"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /profiles/enable_custom_pin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_custom_pin_profiles_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[6,"enable_custom_pin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profiles/enable_dynamic_pin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_dynamic_pin_profiles_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[6,"enable_dynamic_pin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/processes/:id/export(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_abstract_workflow_process_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/processes/:id/export(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_economic_crime_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/processes/:id/export(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_karin_law_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/processes/:id/export(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_laboral_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/webhook/dt_responses/failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const failure_api_v1_webhook_dt_responses_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"webhook"],[2,[7,"/"],[2,[6,"dt_responses"],[2,[7,"/"],[2,[6,"failure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /faq(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faq_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"faq"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /faq-est(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faq_est_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"faq-est"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/controldoc_form/documents/:id/fill(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fill_portal_controldoc_form_document_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"fill"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/controldoc_form/documents/:id/filled(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filled_portal_controldoc_form_document_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"filled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/employees/find_by(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_by_api_v1_laboral_employees_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"find_by"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/employees/find_by(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_by_api_v2_laboral_employees_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"find_by"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/employee_email_changes/:id/finish(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finish_portal_employee_email_change_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"employee_email_changes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"finish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firma-electronica(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firma_electronica_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"firma-electronica"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /firma-tus-documentos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firma_tus_documentos_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"firma-tus-documentos"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/password_expired/forgot_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forgot_password_user_password_expired_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password_expired"],[2,[7,"/"],[2,[6,"forgot_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /forms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forms_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"forms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/versioner/document/comparisons/:id/generate_ai_summary(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_ai_summary_portal_versioner_document_comparison_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_ai_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /versioner/document/comparisons/:id/generate_ai_summary(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_ai_summary_versioner_document_comparison_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_ai_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/hiring_documents/generate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_api_v1_laboral_hiring_documents_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/arauco/laboral/hiring_documents/generate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_api_v2_arauco_laboral_hiring_documents_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"arauco"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/hiring_documents/generate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_api_v2_laboral_hiring_documents_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /gestion-documental(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gestion_documental_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"gestion-documental"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/documents/get_by_ids(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_by_ids_abstract_documents_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"get_by_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/agreement_documents/get_by_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_by_ids_corporate_agreement_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreement_documents"],[2,[7,"/"],[2,[6,"get_by_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/hiring_documents/get_by_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_by_ids_laboral_hiring_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[6,"get_by_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /gracias(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gracias_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"gracias"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const group_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groups_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /inscripcion(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inscripcion_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"inscripcion"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/invite(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invite_admin_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/complaints/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const karin_law_complaint_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"complaints"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/complaints(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const karin_law_complaints_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"complaints"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/custom_fields/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const karin_law_custom_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/custom_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const karin_law_custom_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"custom_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/document_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const karin_law_document_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/document_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const karin_law_document_types_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/edges/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const karin_law_workflow_edge_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"edges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/edges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const karin_law_workflow_edges_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"edges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const karin_law_workflow_groups_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/processes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const karin_law_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/processes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const karin_law_workflow_processes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/requirements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const karin_law_workflow_requirement_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/requirement_stages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const karin_law_workflow_requirement_stage_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/requirements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const karin_law_workflow_requirements_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/stages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const karin_law_workflow_stage_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/stages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const karin_law_workflow_stages_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"stages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/arauco/docx_merge_fields/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_load_arauco_docx_merge_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"arauco"],[2,[7,"/"],[2,[6,"docx_merge_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/arauco/docx_merge_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_load_arauco_docx_merge_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"arauco"],[2,[7,"/"],[2,[6,"docx_merge_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/employees/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_load_employee_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/employees(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_load_employees_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"employees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/hirings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_load_hiring_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"hirings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/hiring_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_load_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/hiring_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_load_hiring_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"hiring_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/hirings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_load_hirings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"hirings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/my_filters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_my_filter_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"my_filters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/my_filters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_my_filters_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"my_filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/notification/fills/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_notification_fill_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[6,"fills"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/notification/fill_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_notification_fill_item_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[6,"fill_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/notification/fills(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_notification_fills_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[6,"fills"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/notification/signs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_notification_sign_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[6,"signs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/notification/sign_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_notification_sign_item_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[6,"sign_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/notification/signs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_notification_signs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[6,"signs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/request/destroy_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_request_destroy_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"destroy_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/request/destroy_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_request_destroy_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"destroy_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/request/destroy_employees/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_request_destroy_employee_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"destroy_employees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/request/destroy_employee_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_request_destroy_employee_item_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"destroy_employee_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/request/destroy_employees(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_request_destroy_employees_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"destroy_employees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/request/hiring_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_request_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/request/hiring_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_request_hiring_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"hiring_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/request/hiring_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_request_hiring_item_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"hiring_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/request/zip/documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_request_zip_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/request/zip/documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_bulk_request_zip_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/check_list/hiring_processes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_check_list_hiring_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"hiring_processes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/check_list/hiring_processes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_check_list_hiring_processes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"hiring_processes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/check_list/hiring_tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_check_list_hiring_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"hiring_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/check_list/hiring_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_check_list_hiring_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"hiring_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/hirings/:id/controldoc_consent_annex/hiring_documents(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_controldoc_consent_annex_hiring_documents_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hirings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"controldoc_consent_annex"],[2,[7,"/"],[2,[6,"hiring_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/controldoc_form/documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_controldoc_form_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/controldoc_form/documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_controldoc_form_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/controldoc_form/templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_controldoc_form_template_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/controldoc_form/template_layouts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_controldoc_form_template_layout_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"template_layouts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/controldoc_form/template_layouts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_controldoc_form_template_layouts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"template_layouts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/controldoc_form/templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_controldoc_form_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/custom_fields/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_custom_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/custom_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_custom_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"custom_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /laboral/document_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_document_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/document_type_batteries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_document_type_batteries_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"document_type_batteries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /laboral/document_type_batteries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_document_type_battery_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"document_type_batteries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/document_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_document_types_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /laboral/employees/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_employee_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/employee_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_employee_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employee_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/employee_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_employee_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employee_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /laboral/employees/:employee_id/email_changes/:id(.:format)
 * @param {any} employee_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_employee_email_change_path = /*#__PURE__*/ __route({"employee_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"employee_id"],[2,[7,"/"],[2,[6,"email_changes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/employees/:employee_id/email_changes(.:format)
 * @param {any} employee_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_employee_email_changes_path = /*#__PURE__*/ __route({"employee_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[3,"employee_id"],[2,[7,"/"],[2,[6,"email_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/employees(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_employees_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /laboral/hirings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_hiring_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hirings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/hiring_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/hiring_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_hiring_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /laboral/hirings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_hirings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hirings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /laboral/shortlist/mapping_configs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_shortlist_mapping_configs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"shortlist"],[2,[7,"/"],[2,[6,"mapping_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/signers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_signer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/signers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_signers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"signers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/edges/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_workflow_edge_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"edges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/edges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_workflow_edges_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"edges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_workflow_groups_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/processes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/processes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_workflow_processes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/requirements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_workflow_requirement_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/requirement_stages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_workflow_requirement_stage_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/requirements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_workflow_requirements_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/stages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_workflow_stage_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/stages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laboral_workflow_stages_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"stages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /post/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const landing_blog_post_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"post"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/controldoc_form/templates/:id/mapping_links(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mapping_links_abstract_controldoc_form_template_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mapping_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/controldoc_form/templates/:id/mapping_links(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mapping_links_corporate_controldoc_form_template_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mapping_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/controldoc_form/templates/:id/mapping_links(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mapping_links_laboral_controldoc_form_template_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mapping_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/billing/quote/abstract_entities/max_per_period(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const max_per_period_api_v1_billing_quote_abstract_entities_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"quote"],[2,[7,"/"],[2,[6,"abstract_entities"],[2,[7,"/"],[2,[6,"max_per_period"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/billing/quote/active_employees/max_per_period(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const max_per_period_api_v1_billing_quote_active_employees_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"quote"],[2,[7,"/"],[2,[6,"active_employees"],[2,[7,"/"],[2,[6,"max_per_period"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/billing/quote/advance_signatures/max_per_period(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const max_per_period_api_v1_billing_quote_advance_signatures_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"quote"],[2,[7,"/"],[2,[6,"advance_signatures"],[2,[7,"/"],[2,[6,"max_per_period"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/billing/quote/gb_useds/max_per_period(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const max_per_period_api_v1_billing_quote_gb_useds_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"quote"],[2,[7,"/"],[2,[6,"gb_useds"],[2,[7,"/"],[2,[6,"max_per_period"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/billing/quote/inactive_employees/max_per_period(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const max_per_period_api_v1_billing_quote_inactive_employees_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"quote"],[2,[7,"/"],[2,[6,"inactive_employees"],[2,[7,"/"],[2,[6,"max_per_period"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/billing/quote/members/max_per_period(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const max_per_period_api_v1_billing_quote_members_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"quote"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"max_per_period"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/billing/quote/storages/max_per_period(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const max_per_period_api_v1_billing_quote_storages_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"quote"],[2,[7,"/"],[2,[6,"storages"],[2,[7,"/"],[2,[6,"max_per_period"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mcp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mcp_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /media/images/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_image_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /media/images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_images_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /memberships/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const membership_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /memberships(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const memberships_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/arauco/docx_merge_fields/metadata_file_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const metadata_file_data_laboral_bulk_load_arauco_docx_merge_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"arauco"],[2,[7,"/"],[2,[6,"docx_merge_fields"],[2,[7,"/"],[2,[6,"metadata_file_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/arauco/docx_merge_fields/metadata_file_template(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const metadata_file_template_laboral_bulk_load_arauco_docx_merge_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"arauco"],[2,[7,"/"],[2,[6,"docx_merge_fields"],[2,[7,"/"],[2,[6,"metadata_file_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboards/metrics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const metrics_dashboards_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/load/documents/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_bulk_load_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/load/entities/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_bulk_load_entity_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"entities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/notification/signs/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_bulk_notification_sign_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[6,"signs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/request/documents/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_bulk_request_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/bulk/request/zip/documents/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_bulk_request_zip_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/check_list/processes/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_check_list_process_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/controldoc_form/templates/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_controldoc_form_template_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/controldoc_form/template_layouts/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_controldoc_form_template_layout_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"template_layouts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/custom_fields/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_custom_field_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/documents/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/document_types/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_document_type_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/document_type_batteries/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_document_type_battery_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"document_type_batteries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entities/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_entity_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_lists/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_entity_folder_check_list_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_list_requirements/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_entity_folder_check_list_requirement_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_requirements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_list_shareds/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_entity_folder_check_list_shared_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_shareds"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/fao/mapping_configs/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_fao_mapping_config_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"fao"],[2,[7,"/"],[2,[6,"mapping_configs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/report/documents/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_report_document_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/report/signers/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_report_signer_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/signers/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_signer_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/processes/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_workflow_process_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/requirements/new(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_abstract_workflow_requirement_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/abstract_entity_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_abstract_entity_type_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abstract_entity_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/abstract_entity_type_configs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_abstract_entity_type_config_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abstract_entity_type_configs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_admin_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/blog_posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_blog_post_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog_posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/change_logs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_change_log_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"change_logs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/communication_channels/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_communication_channel_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"communication_channels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/compliance_contexts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_compliance_context_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"compliance_contexts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_budgets/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_crm_budget_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_budgets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_budget_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_crm_budget_template_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_budget_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_post_sale_interviews/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_crm_post_sale_interview_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_post_sale_interviews"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_post_sale_tasks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_crm_post_sale_task_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_post_sale_tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_pre_sale_interviews/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_crm_pre_sale_interview_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_pre_sale_interviews"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_pre_sale_tasks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_crm_pre_sale_task_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_pre_sale_tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_task_reports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_crm_task_report_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_task_reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tech_tasks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_crm_tech_task_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tech_tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tutorial_capsules/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_crm_tutorial_capsule_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tutorial_capsules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tutorial_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_crm_tutorial_template_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tutorial_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_tutorial_tours/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_crm_tutorial_tour_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_tutorial_tours"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_customer_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_onboarding_processes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_customer_onboarding_process_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_onboarding_processes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_service_suspensions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_customer_service_suspension_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_service_suspensions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ecert_signature_certificates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_ecert_signature_certificate_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ecert_signature_certificates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_provider_routing_domains/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_email_provider_routing_domain_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_provider_routing_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_provider_smtp_accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_email_provider_smtp_account_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_provider_smtp_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/nps_records/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_nps_record_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nps_records"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/nps_results/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_nps_result_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nps_results"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/oauth_clients/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_oauth_client_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"oauth_clients"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_documentations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_page_documentation_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_documentations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_product_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/roles/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_role_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/system_notifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_system_notification_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"system_notifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/laboral/hiring_documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_laboral_hiring_document_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/laboral/hiring_documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v2_laboral_hiring_document_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /blog/posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_blog_post_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /calendar/work_schedules/:calendar_id/holiday_events/new(.:format)
 * @param {any} calendar_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_calendar_holiday_event_path = /*#__PURE__*/ __route({"calendar_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"work_schedules"],[2,[7,"/"],[2,[3,"calendar_id"],[2,[7,"/"],[2,[6,"holiday_events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /calendar/work_schedules/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_calendar_work_schedule_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"work_schedules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/activities/new(.:format)
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_compliance_activity_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/activities/:activity_id/evidence_loads/new(.:format)
 * @param {any} compliance_context_id
 * @param {any} activity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_compliance_activity_evidence_load_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"activity_id"],[2,[7,"/"],[2,[6,"evidence_loads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/bulk/load/activities/new(.:format)
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_compliance_bulk_load_activity_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/custom_fields/new(.:format)
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_compliance_custom_field_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/groups/new(.:format)
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_compliance_group_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/risk_levels/new(.:format)
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_compliance_risk_level_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"risk_levels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/tasks/new(.:format)
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_compliance_task_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/agreements/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_corporate_agreement_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/agreement_documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_corporate_agreement_document_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreement_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/bulk/notification/signs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_corporate_bulk_notification_sign_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[6,"signs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/bulk/request/agreement_documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_corporate_bulk_request_agreement_document_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"agreement_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/bulk/request/zip/documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_corporate_bulk_request_zip_document_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/check_list/agreement_processes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_corporate_check_list_agreement_process_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"agreement_processes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/companies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_corporate_company_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/controldoc_form/templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_corporate_controldoc_form_template_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/controldoc_form/template_layouts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_corporate_controldoc_form_template_layout_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"template_layouts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/custom_fields/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_corporate_custom_field_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/document_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_corporate_document_type_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/document_type_batteries/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_corporate_document_type_battery_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"document_type_batteries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/signers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_corporate_signer_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /default_signers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_default_signer_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"default_signers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dt/bulk/load/annexe_records/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_dt_bulk_load_annexe_record_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"annexe_records"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/bulk/load/contract_records/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_dt_bulk_load_contract_record_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"contract_records"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/mapping_fields/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_dt_mapping_field_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"mapping_fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/setting/fetch_dt_info_requests/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_dt_setting_fetch_dt_info_request_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"setting"],[2,[7,"/"],[2,[6,"fetch_dt_info_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecert/signature_certificates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecert_signature_certificate_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"ecert"],[2,[7,"/"],[2,[6,"signature_certificates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/processes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_economic_crime_workflow_process_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/requirements/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_economic_crime_workflow_requirement_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /groups/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_group_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/processes/new_import_json(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_import_json_abstract_workflow_processes_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"new_import_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/processes/new_import_json(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_import_json_economic_crime_workflow_processes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"new_import_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/processes/new_import_json(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_import_json_karin_law_workflow_processes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"new_import_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/processes/new_import_json(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_import_json_laboral_workflow_processes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"new_import_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/complaints/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_karin_law_complaint_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"complaints"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/custom_fields/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_karin_law_custom_field_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/document_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_karin_law_document_type_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/processes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_karin_law_workflow_process_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/requirements/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_karin_law_workflow_requirement_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/arauco/docx_merge_fields/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_bulk_load_arauco_docx_merge_field_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"arauco"],[2,[7,"/"],[2,[6,"docx_merge_fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/employees/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_bulk_load_employee_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/hirings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_bulk_load_hiring_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"hirings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/hiring_documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_bulk_load_hiring_document_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/my_filters/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_bulk_my_filter_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"my_filters"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/notification/fills/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_bulk_notification_fill_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[6,"fills"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/notification/signs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_bulk_notification_sign_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[2,[6,"signs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/request/destroy_documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_bulk_request_destroy_document_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"destroy_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/request/destroy_employees/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_bulk_request_destroy_employee_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"destroy_employees"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/request/hiring_documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_bulk_request_hiring_document_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/request/zip/documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_bulk_request_zip_document_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"request"],[2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/check_list/hiring_processes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_check_list_hiring_process_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"hiring_processes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/hirings/:id/controldoc_consent_annex/hiring_documents/new(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_controldoc_consent_annex_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hirings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"controldoc_consent_annex"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/controldoc_form/templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_controldoc_form_template_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/controldoc_form/template_layouts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_controldoc_form_template_layout_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"template_layouts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/custom_fields/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_custom_field_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/document_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_document_type_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/document_type_batteries/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_document_type_battery_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"document_type_batteries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/employees/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_employee_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/employee_documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_employee_document_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employee_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/hirings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_hiring_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hirings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/hiring_documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_hiring_document_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/signers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_signer_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/processes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_workflow_process_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/requirements/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laboral_workflow_requirement_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /memberships/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_membership_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/abstract/workflow/requirements/new(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_portal_abstract_workflow_requirement_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/compliance/:compliance_context_id/activities/new(.:format)
 * @param {any} tenant
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_portal_compliance_activity_path = /*#__PURE__*/ __route({"tenant":{"r":true},"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/compliance/:compliance_context_id/activities/:activity_id/evidence_loads/new(.:format)
 * @param {any} tenant
 * @param {any} compliance_context_id
 * @param {any} activity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_portal_compliance_activity_evidence_load_path = /*#__PURE__*/ __route({"tenant":{"r":true},"compliance_context_id":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"activity_id"],[2,[7,"/"],[2,[6,"evidence_loads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/economic_crime/workflow/requirements/new(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_portal_economic_crime_workflow_requirement_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/karin_law/workflow/requirements/new(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_portal_karin_law_workflow_requirement_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/laboral/workflow/requirements/new(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_portal_laboral_workflow_requirement_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/sessions/new(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_portal_session_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/versioner/document/threads/new(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_portal_versioner_document_thread_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/versioner/document/threads/:thread_id/items/new(.:format)
 * @param {any} tenant
 * @param {any} thread_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_portal_versioner_document_thread_item_path = /*#__PURE__*/ __route({"tenant":{"r":true},"thread_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"thread_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/workflow/requirements/new(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_portal_workflow_requirement_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/abstract/workflow/requirements/:customer_id/:process_id/new(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_public_abstract_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/delitos_economicos/denuncia/:customer_id/:process_id/new(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_public_economic_crime_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"delitos_economicos"],[2,[7,"/"],[2,[6,"denuncia"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/ley_karin/denuncia/:customer_id/:process_id/new(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_public_karin_law_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"ley_karin"],[2,[7,"/"],[2,[6,"denuncia"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/laboral/workflow/requirements/:customer_id/:process_id/new(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_public_laboral_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /report/corporate/agreement_documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_report_corporate_agreement_document_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreement_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /report/corporate/signers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_report_corporate_signer_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /report/laboral/hirings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_report_laboral_hiring_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hirings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /report/laboral/hiring_documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_report_laboral_hiring_document_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /report/laboral/signers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_report_laboral_signer_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shared/entity_folder/check_list_shareds/:id/requirement/:folder_id(.:format)
 * @param {any} id
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_requirement_shared_entity_folder_check_list_shared_path = /*#__PURE__*/ __route({"id":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shared"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_shareds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"requirement"],[2,[7,"/"],[2,[3,"folder_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security_layers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_security_layer_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"security_layers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /signers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_signer_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/invitation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_invitation_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"invitation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /versioner/document/threads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_versioner_document_thread_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /versioner/document/threads/:thread_id/items/new(.:format)
 * @param {any} thread_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_versioner_document_thread_item_path = /*#__PURE__*/ __route({"thread_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"thread_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_onboarding_processes/next_step(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const next_step_customer_onboarding_processes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"customer_onboarding_processes"],[2,[7,"/"],[2,[6,"next_step"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /normative(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const normative_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"normative"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/custom_fields/order(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_abstract_custom_fields_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/custom_fields/order(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_laboral_custom_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgs_path = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /partners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const partners_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"partners"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/tasks/:id/pending(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pending_compliance_task_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pending"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/sessions/pending_profile(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pending_profile_portal_sessions_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"pending_profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_onboarding_processes/:id/pin_form/:responsible(.:format)
 * @param {any} id
 * @param {any} responsible
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pin_form_customer_onboarding_process_path = /*#__PURE__*/ __route({"id":{"r":true},"responsible":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_onboarding_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pin_form"],[2,[7,"/"],[2,[3,"responsible"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/abstract/workflow/requirements/:id(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_abstract_workflow_requirement_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/abstract/workflow/requirement_stages/:id(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_abstract_workflow_requirement_stage_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/abstract/workflow/requirements(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_abstract_workflow_requirements_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/blog/posts/:id(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_blog_post_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/blog/posts(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_blog_posts_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/comment/versioner/document/items/:resource_id(.:format)
 * @param {any} tenant
 * @param {any} resource_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_comment_versioner_document_items_path = /*#__PURE__*/ __route({"tenant":{"r":true},"resource_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"comment"],[2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"resource_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/comment/workflow/requirements/:resource_id(.:format)
 * @param {any} tenant
 * @param {any} resource_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_comment_workflow_requirements_path = /*#__PURE__*/ __route({"tenant":{"r":true},"resource_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"comment"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"resource_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/compliance/:compliance_context_id/activities(.:format)
 * @param {any} tenant
 * @param {any} compliance_context_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_compliance_activities_path = /*#__PURE__*/ __route({"tenant":{"r":true},"compliance_context_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/compliance/:compliance_context_id/activities/:id(.:format)
 * @param {any} tenant
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_compliance_activity_path = /*#__PURE__*/ __route({"tenant":{"r":true},"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/compliance/:compliance_context_id/activities/:activity_id/evidence_loads(.:format)
 * @param {any} tenant
 * @param {any} compliance_context_id
 * @param {any} activity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_compliance_activity_evidence_loads_path = /*#__PURE__*/ __route({"tenant":{"r":true},"compliance_context_id":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"activity_id"],[2,[7,"/"],[2,[6,"evidence_loads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/compliance/:compliance_context_id/evidence_loads/:id(.:format)
 * @param {any} tenant
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_compliance_evidence_load_path = /*#__PURE__*/ __route({"tenant":{"r":true},"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"evidence_loads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /portal/configurations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_configurations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/controldoc_form/documents/:id(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_controldoc_form_document_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/custom_pins(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_custom_pins_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"custom_pins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:id/portal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_customer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"portal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/dashboards(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_dashboards_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"dashboards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/document_compressions/:id(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_document_compression_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{"d":"zip"}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"document_compressions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/document_compressions(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_document_compressions_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"document_compressions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/documents(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_documents_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/ecert/bulk_signings(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_ecert_bulk_signings_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"ecert"],[2,[7,"/"],[2,[6,"bulk_signings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/economic_crime/workflow/requirements/:id(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_economic_crime_workflow_requirement_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/economic_crime/workflow/requirement_stages/:id(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_economic_crime_workflow_requirement_stage_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/economic_crime/workflow/requirements(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_economic_crime_workflow_requirements_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/employee_email_changes/:id(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_employee_email_change_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"employee_email_changes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/karin_law/workflow/requirements/:id(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_karin_law_workflow_requirement_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/karin_law/workflow/requirement_stages/:id(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_karin_law_workflow_requirement_stage_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/karin_law/workflow/requirements(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_karin_law_workflow_requirements_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/laboral/workflow/requirements/:id(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_laboral_workflow_requirement_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/laboral/workflow/requirement_stages/:id(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_laboral_workflow_requirement_stage_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirement_stages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/laboral/workflow/requirements(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_laboral_workflow_requirements_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/sessions(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_sessions_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/sign_documents(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_sign_documents_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"sign_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/versioner/document/comparisons/:id(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_versioner_document_comparison_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/versioner/document/comparisons(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_versioner_document_comparisons_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"comparisons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/versioner/document/threads/:id(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_versioner_document_thread_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/versioner/document/threads/:thread_id/items/:id(.:format)
 * @param {any} tenant
 * @param {any} thread_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_versioner_document_thread_item_path = /*#__PURE__*/ __route({"tenant":{"r":true},"thread_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"thread_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/versioner/document/threads/:thread_id/items(.:format)
 * @param {any} tenant
 * @param {any} thread_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_versioner_document_thread_items_path = /*#__PURE__*/ __route({"tenant":{"r":true},"thread_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"thread_id"],[2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/versioner/document/threads(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_versioner_document_threads_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"threads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/workflow/requirements(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portal_workflow_requirements_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/controldoc_form/template_layouts/preview(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_abstract_controldoc_form_template_layouts_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{"d":"pdf"}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"template_layouts"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_budgets/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_admin_crm_budget_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_budgets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_onboarding_processes/:id/preview_comercial_conditions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_comercial_conditions_customer_onboarding_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"pdf"}}, [2,[7,"/"],[2,[6,"customer_onboarding_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_comercial_conditions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/controldoc_form/template_layouts/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_corporate_controldoc_form_template_layouts_path = /*#__PURE__*/ __route({"format":{"d":"pdf"}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"template_layouts"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/check_list/hiring_tasks/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_laboral_check_list_hiring_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"hiring_tasks"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/controldoc_form/template_layouts/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_laboral_controldoc_form_template_layouts_path = /*#__PURE__*/ __route({"format":{"d":"pdf"}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"template_layouts"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /media/images/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_media_image_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/controldoc_form/documents/:id/preview_pdf(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_pdf_portal_controldoc_form_document_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/documents/:id/preview(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_portal_document_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/sign_documents/:id/preview(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_portal_sign_document_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"sign_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /privacy_policy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacy_policy_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"privacy_policy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /profiles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profiles_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profiles"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /public/abstract/workflow/requirements/:customer_id/:process_id/:id(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_abstract_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/abstract/workflow/requirements/:customer_id/:process_id(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_abstract_workflow_requirements_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"abstract"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/comment/workflow/requirements/:resource_id/:customer_id(.:format)
 * @param {any} resource_id
 * @param {any} customer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_comment_workflow_requirements_path = /*#__PURE__*/ __route({"resource_id":{"r":true},"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"comment"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[3,"customer_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/crm/leads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_crm_lead_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"crm"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/crm/tutorial/tours/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_crm_tutorial_tour_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"crm"],[2,[7,"/"],[2,[6,"tutorial"],[2,[7,"/"],[2,[6,"tours"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/crm/tutorial/tour_capsules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_crm_tutorial_tour_capsule_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"crm"],[2,[7,"/"],[2,[6,"tutorial"],[2,[7,"/"],[2,[6,"tour_capsules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/delitos_economicos/denuncia/:customer_id/:process_id/:id(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_economic_crime_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"delitos_economicos"],[2,[7,"/"],[2,[6,"denuncia"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/delitos_economicos/denuncia/:customer_id/:process_id(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_economic_crime_workflow_requirements_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"delitos_economicos"],[2,[7,"/"],[2,[6,"denuncia"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/ley_karin/denuncia/:customer_id/:process_id/:id(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_karin_law_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"ley_karin"],[2,[7,"/"],[2,[6,"denuncia"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/ley_karin/denuncia/:customer_id/:process_id(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_karin_law_workflow_requirements_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"ley_karin"],[2,[7,"/"],[2,[6,"denuncia"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/laboral/workflow/requirements/:customer_id/:process_id/:id(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_laboral_workflow_requirement_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/laboral/workflow/requirements/:customer_id/:process_id(.:format)
 * @param {any} customer_id
 * @param {any} process_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_laboral_workflow_requirements_path = /*#__PURE__*/ __route({"customer_id":{"r":true},"process_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[3,"process_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/processes/:id/public_qr_code(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_qr_code_abstract_workflow_process_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"public_qr_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/processes/:id/public_qr_code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_qr_code_economic_crime_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"public_qr_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/processes/:id/public_qr_code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_qr_code_karin_law_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"public_qr_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/processes/:id/public_qr_code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_qr_code_laboral_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"public_qr_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/processes/:id/publish(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_abstract_workflow_process_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/activity_containers/:id/publish_activities(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_activities_compliance_activity_container_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"activity_containers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/processes/:id/publish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_economic_crime_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/processes/:id/publish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_karin_law_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/processes/:id/publish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_laboral_workflow_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __route({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_health_check_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/performance
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_performance_path = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[6,"performance"]]]]);

/**
 * Generates rails route to
 * /rails/performance/assets/*file(.:format)
 * @param {any} file
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_performance_engine_asset_path = /*#__PURE__*/ __route({"file":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[6,"performance"]]]],[7,"/"]],[2,[6,"assets"],[2,[7,"/"],[2,[5,[3,"file"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/performance/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_performance_rails_performance_path = /*#__PURE__*/ __route({}, [2,[2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[6,"performance"]]]],[7,"/"]]);

/**
 * Generates rails route to
 * /rails/performance/crashes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_performance_rails_performance_crashes_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[6,"performance"]]]],[7,"/"]],[2,[6,"crashes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/performance/custom(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_performance_rails_performance_custom_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[6,"performance"]]]],[7,"/"]],[2,[6,"custom"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/performance/delayed_job(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_performance_rails_performance_delayed_job_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[6,"performance"]]]],[7,"/"]],[2,[6,"delayed_job"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/performance/grape(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_performance_rails_performance_grape_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[6,"performance"]]]],[7,"/"]],[2,[6,"grape"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/performance/rake(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_performance_rails_performance_rake_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[6,"performance"]]]],[7,"/"]],[2,[6,"rake"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/performance/recent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_performance_rails_performance_recent_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[6,"performance"]]]],[7,"/"]],[2,[6,"recent"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/performance/requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_performance_rails_performance_requests_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[6,"performance"]]]],[7,"/"]],[2,[6,"requests"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/performance/resources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_performance_rails_performance_resources_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[6,"performance"]]]],[7,"/"]],[2,[6,"resources"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/performance/sidekiq(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_performance_rails_performance_sidekiq_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[6,"performance"]]]],[7,"/"]],[2,[6,"sidekiq"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/performance/slow(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_performance_rails_performance_slow_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[6,"performance"]]]],[7,"/"]],[2,[6,"slow"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/performance/summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_performance_rails_performance_summary_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[6,"performance"]]]],[7,"/"]],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/performance/trace/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_performance_rails_performance_trace_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[6,"performance"]]]],[7,"/"]],[2,[6,"trace"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/castano/laboral/employees/receive(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receive_api_v1_castano_laboral_employees_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"castano"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"receive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/castano/laboral/hirings/receive(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receive_api_v1_castano_laboral_hirings_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"castano"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hirings"],[2,[7,"/"],[2,[6,"receive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/webhook/ecert/documents/receive(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receive_api_v1_webhook_ecert_documents_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"webhook"],[2,[7,"/"],[2,[6,"ecert"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"receive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/webhook/email_provider/sendgrid/inbound_events/receive(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receive_api_v1_webhook_email_provider_sendgrid_inbound_events_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"webhook"],[2,[7,"/"],[2,[6,"email_provider"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_events"],[2,[7,"/"],[2,[6,"receive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /recursos/casos-de-exito(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recursos_casos_de_exito_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"recursos"],[2,[7,"/"],[2,[6,"casos-de-exito"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /recursos/ebook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recursos_ebook_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"recursos"],[2,[7,"/"],[2,[6,"ebook"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /laboral/check_list/hiring_processes/:id/refresh(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_laboral_check_list_hiring_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"hiring_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/invitation/remove(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_user_invitation_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"invitation"],[2,[7,"/"],[2,[6,"remove"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /report/corporate/agreement_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_corporate_agreement_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreement_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /report/corporate/agreement_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_corporate_agreement_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"agreement_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /report/corporate/signers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_corporate_signer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /report/corporate/signers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_corporate_signers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"signers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /report/laboral/hirings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_laboral_hiring_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hirings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /report/laboral/hiring_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_laboral_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /report/laboral/hiring_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_laboral_hiring_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /report/laboral/hirings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_laboral_hirings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hirings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /report/laboral/signers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_laboral_signer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /report/laboral/signers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_laboral_signers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"signers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_onboarding_processes/:id/request_pin(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_pin_customer_onboarding_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_onboarding_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_pin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/bulk/load/annexe_records/:id/request_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_status_dt_bulk_load_annexe_record_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"annexe_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/bulk/load/contract_records/:id/request_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_status_dt_bulk_load_contract_record_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"contract_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /documents/:id/request_validate_otp(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_validate_otp_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_validate_otp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/employee_email_changes/resend_token(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_token_portal_employee_email_changes_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"employee_email_changes"],[2,[7,"/"],[2,[6,"resend_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/custom_pins/reset(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_portal_custom_pins_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"custom_pins"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /nps/results/:id/respond(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const respond_nps_result_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"nps"],[2,[7,"/"],[2,[6,"results"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"respond"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/unsubscribed_emails/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_admin_unsubscribed_email_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"unsubscribed_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_context_id/evidence_files/:id/review(.:format)
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const review_compliance_evidence_file_path = /*#__PURE__*/ __route({"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"evidence_files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/hiring_documents/:id/review(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const review_laboral_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/compliance/:compliance_context_id/evidence_files/:id/review(.:format)
 * @param {any} tenant
 * @param {any} compliance_context_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const review_portal_compliance_evidence_file_path = /*#__PURE__*/ __route({"tenant":{"r":true},"compliance_context_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_context_id"],[2,[7,"/"],[2,[6,"evidence_files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/hiring_documents/:id/reviewed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewed_laboral_hiring_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"hiring_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reviewed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /calendar/work_schedules/:id/save_chilean_holidays(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_chilean_holidays_calendar_work_schedule_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"work_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"save_chilean_holidays"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dt/corporate/company/:resource_id/credentials/save(.:format)
 * @param {any} resource_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_dt_corporate_company_credentials_path = /*#__PURE__*/ __route({"resource_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[6,"save"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/workflow/processes/save_import_json(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_import_json_abstract_workflow_processes_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"save_import_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /economic_crime/workflow/processes/save_import_json(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_import_json_economic_crime_workflow_processes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"economic_crime"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"save_import_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /karin_law/workflow/processes/save_import_json(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_import_json_karin_law_workflow_processes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"karin_law"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"save_import_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/workflow/processes/save_import_json(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_import_json_laboral_workflow_processes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"workflow"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"save_import_json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/documents/:id/save_upload(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_upload_portal_document_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"save_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/shortlist/assessment_load/callbacks/:id/screenings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const screenings_api_v1_shortlist_assessment_load_callback_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"shortlist"],[2,[7,"/"],[2,[6,"assessment_load"],[2,[7,"/"],[2,[6,"callbacks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"screenings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/communication_channels/search_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_emails_admin_communication_channels_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"communication_channels"],[2,[7,"/"],[2,[6,"search_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /security_layers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_layer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security_layers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security_layers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_layers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"security_layers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /signers/send_email_require_identity_verification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_email_require_identity_verification_signers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[6,"send_email_require_identity_verification"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profiles/send_otp_code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_otp_code_profiles_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[6,"send_otp_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/employee_email_changes/send_pin_code_email(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_pin_code_email_portal_employee_email_changes_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"employee_email_changes"],[2,[7,"/"],[2,[6,"send_pin_code_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/sessions/send_pin_code_email(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_pin_code_email_portal_sessions_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{"d":"js"}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"send_pin_code_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/bulk/load/arauco/docx_merge_fields/:id/send_to_sign(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_to_sign_laboral_bulk_load_arauco_docx_merge_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"load"],[2,[7,"/"],[2,[6,"arauco"],[2,[7,"/"],[2,[6,"docx_merge_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_to_sign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/employee_email_changes/send_token(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_token_portal_employee_email_changes_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"employee_email_changes"],[2,[7,"/"],[2,[6,"send_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/check_list/processes/:id/share(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const share_abstract_check_list_process_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"share"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /corporate/check_list/agreement_processes/:id/share(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const share_corporate_check_list_agreement_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"agreement_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"share"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/check_list/hiring_processes/:id/share(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const share_laboral_check_list_hiring_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"check_list"],[2,[7,"/"],[2,[6,"hiring_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"share"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shared/entity_folder/check_list_shareds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shared_entity_folder_check_list_shared_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shared"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_shareds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shared/entity_folder/check_list_tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shared_entity_folder_check_list_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shared"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiq_web_path = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"sidekiq"]]);

/**
 * Generates rails route to
 * /signers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"signers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /signer_notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signer_notifications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"signer_notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /signers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"signers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /solucion(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const solucion_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"solucion"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/webhook/dt_responses/success(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_api_v1_webhook_dt_responses_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"webhook"],[2,[7,"/"],[2,[6,"dt_responses"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/sign_documents/success_rejection(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_rejection_portal_sign_documents_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"sign_documents"],[2,[7,"/"],[2,[6,"success_rejection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/sign_documents/success_sign(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_sign_portal_sign_documents_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"sign_documents"],[2,[7,"/"],[2,[6,"success_sign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_budgets/:id/switch_state(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switch_state_admin_crm_budget_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_budgets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"switch_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/crm_leads/:id/switch_state(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switch_state_admin_crm_lead_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"crm_leads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"switch_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /switch_user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switch_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"switch_user"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /switch_user/remember_user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switch_user_remember_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"switch_user"],[2,[7,"/"],[2,[6,"remember_user"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /corporate/controldoc_form/templates/sync(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_corporate_controldoc_form_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/controldoc_form/templates/sync(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_laboral_controldoc_form_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"controldoc_form"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shared/entity_folder/check_list_shareds/:id/task/:task_id(.:format)
 * @param {any} id
 * @param {any} task_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_shared_entity_folder_check_list_shared_path = /*#__PURE__*/ __route({"id":{"r":true},"task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shared"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_shareds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[3,"task_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_onboarding_processes/terms_and_conditions_pdf(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_and_conditions_pdf_customer_onboarding_processes_path = /*#__PURE__*/ __route({"format":{"d":"pdf"}}, [2,[7,"/"],[2,[6,"customer_onboarding_processes"],[2,[7,"/"],[2,[6,"terms_and_conditions_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /terms_of_service(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_of_service_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms_of_service"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dt/setting/fetch_dt_info_requests/test_endpoint(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_endpoint_dt_setting_fetch_dt_info_requests_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dt"],[2,[7,"/"],[2,[6,"setting"],[2,[7,"/"],[2,[6,"fetch_dt_info_requests"],[2,[7,"/"],[2,[6,"test_endpoint"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /thanks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thanks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"thanks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tutorial(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tutorial_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tutorial"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/sessions/two_factor_authentication(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const two_factor_authentication_portal_sessions_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"two_factor_authentication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /profiles/update_cellphone(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_cellphone_profiles_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[6,"update_cellphone"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:id/update_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_data_customer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_list_tasks/:id/update_file(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_file_abstract_entity_folder_check_list_task_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shared/entity_folder/check_list_shareds/:id/task/:task_id/update_file(.:format)
 * @param {any} id
 * @param {any} task_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_file_shared_entity_folder_check_list_shared_path = /*#__PURE__*/ __route({"id":{"r":true},"task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shared"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_shareds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"update_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shared/entity_folder/check_list_tasks/:id/update_file(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_file_shared_entity_folder_check_list_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shared"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/custom_fields/update_order(.:format)
 * @param {any} current_entity_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_order_abstract_custom_fields_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"update_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laboral/custom_fields/update_order(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_order_laboral_custom_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"laboral"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"update_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profiles/update_personal_information(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_personal_information_profiles_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[6,"update_personal_information"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __route({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/change_logs/upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_admin_change_logs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"change_logs"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/webhook/ecert/documents/:id/upload_document(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_document_api_v1_webhook_ecert_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"webhook"],[2,[7,"/"],[2,[6,"ecert"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /module/:current_entity_type_id/entity_folder/check_list_tasks/:id/upload_file(.:format)
 * @param {any} current_entity_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_file_abstract_entity_folder_check_list_task_path = /*#__PURE__*/ __route({"current_entity_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"module"],[2,[7,"/"],[2,[3,"current_entity_type_id"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shared/entity_folder/check_list_shareds/:id/task/:task_id/upload_file(.:format)
 * @param {any} id
 * @param {any} task_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_file_shared_entity_folder_check_list_shared_path = /*#__PURE__*/ __route({"id":{"r":true},"task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shared"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_shareds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"upload_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shared/entity_folder/check_list_tasks/:id/upload_file(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_file_shared_entity_folder_check_list_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shared"],[2,[7,"/"],[2,[6,"entity_folder"],[2,[7,"/"],[2,[6,"check_list_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/documents/:id/upload(.:format)
 * @param {any} tenant
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_portal_document_path = /*#__PURE__*/ __route({"tenant":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/entra_id(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_entra_id_omniauth_authorize_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"entra_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/entra_id/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_entra_id_omniauth_callback_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"entra_id"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/invitation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_invitation_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"invitation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/password_expired(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_expired_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password_expired"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /documents/:id/validate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /documents/:id/validate_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_email_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /documents/:id/validate_otp(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_otp_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate_otp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /documents/:id/validate_otp_form(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_otp_form_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate_otp_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_onboarding_processes/:id/validate_pin(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_pin_customer_onboarding_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_onboarding_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate_pin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:tenant/sessions/validate_user(.:format)
 * @param {any} tenant
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_user_portal_sessions_path = /*#__PURE__*/ __route({"tenant":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"tenant"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"validate_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /versioner/document/comparisons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const versioner_document_comparison_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /versioner/document/comparisons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const versioner_document_comparisons_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"comparisons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /versioner/document/threads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const versioner_document_thread_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /versioner/document/threads/:thread_id/items/:id(.:format)
 * @param {any} thread_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const versioner_document_thread_item_path = /*#__PURE__*/ __route({"thread_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"thread_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /versioner/document/threads/:thread_id/items(.:format)
 * @param {any} thread_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const versioner_document_thread_items_path = /*#__PURE__*/ __route({"thread_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"thread_id"],[2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /versioner/document/threads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const versioner_document_threads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"versioner"],[2,[7,"/"],[2,[6,"document"],[2,[7,"/"],[2,[6,"threads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /welcome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"welcome"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /customer_onboarding_processes/:id/welcome_completed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_completed_customer_onboarding_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_onboarding_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"welcome_completed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_onboarding_processes/:id/welcome(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_customer_onboarding_process_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_onboarding_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"welcome"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /workspace-upgrade(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workspace_upgrade_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"workspace-upgrade"],[1,[2,[8,"."],[3,"format"]]]]]);

